var styles = {"svgContainer":"styles_svg-container__qnTbz","svg":"styles_svg__EZnuN"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
